export default __webpack_public_path__ + "static/media/glasses.1571188e.svg";